/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, November 12th 2021, 1:19:44 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import {
  ProcessTemplateArtifact,
  ProcessTemplateArtifactSchemaType,
  ProcessTemplateArtifactValidationSchema,
  DatasetReference,
} from "lib/schemas";
import { WritableModel } from "lib/schemas/abstract";
import { schemaBuilder, Many2OneIntPKBaseSchema } from "lib/validation";

export enum VALIDATOR_TYPES {
  dataset = "Dataset Validator",
  human_face = "Human Face Validator",
  face_detection = "Face Detection Dataset Validator",
  object_detection = "Object Detection Validator",
}

export interface FieldValidator extends ProcessTemplateArtifact, WritableModel<false> {
  name: string;
  type: keyof typeof VALIDATOR_TYPES;
  dataset_lookup_settings?: { lookup_column: string };
  is_global: boolean;
  error_message?: any;
  validation_dataset_reference?: DatasetReference["id"];
}

export const FieldValidatorValidationSchema: ProcessTemplateArtifactSchemaType<FieldValidator> =
  ProcessTemplateArtifactValidationSchema.shape({
    id: schemaBuilder.number().positive().nullable(),
    name: schemaBuilder.string().required("Name is required"),
    type: schemaBuilder.mixed().oneOf(Object.keys(VALIDATOR_TYPES)).required("Field Validator type is required"),
    is_global: schemaBuilder.boolean().default(false),
    error_message: schemaBuilder.string().optional().nullable(),
    validation_dataset_reference: Many2OneIntPKBaseSchema().required("Dataset Reference is required"),
    dataset_lookup_settings: schemaBuilder
      .object({ lookup_column: schemaBuilder.string().required("Lookup column is required") })
      .required("Lookup Settings is required"),
  });
